export default __webpack_public_path__ + "static/media/sign-in-bg.7a1a3f68.jpg";